module.exports = __webpack_public_path__ + "static/media/8.e43f55ff.png";